import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

import useInterceptors from '../interceptor';
import eventsInterceptor from '../interceptor/interceptors/events';

const API: AxiosInstance = useInterceptors(Axios.create(), [
  eventsInterceptor,
]);

const Endpoint = EndpointFactory(API);

// EVENTS
const EVENTS = 'events';
const MOENGAGE = 'moengage';
export const sendEventIntegrationEndpoint = new Endpoint(`${MOENGAGE}/${EVENTS}`);
